<template>
  <button class="navbar__langSwitch" @click="$i18n.locale = toLocale">
    {{ toLocale }}
  </button>
</template>

<script>
export default {
  name: 'LangSwitch',
  computed: {
    toLocale() {
      return this.$i18n.availableLocales.find((locale) => locale !== this.$i18n.locale)
    },
  },
  watch: {
    '$i18n.locale'() {
      if (this.$store.state.auth.logged_in) this.$store.dispatch('resetRiddles')
    },
  },
}
</script>
